/**
 * Browser file picks for asset create: read bytes and JSON as `data:image/...;base64,...`
 * so backends can persist without a separate multipart route (when the API accepts that shape).
 */

export function readFileAsDataURL(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const x = r.result;
      resolve(typeof x === 'string' ? x : '');
    };
    r.onerror = () => {
      reject(r.error ?? new Error('Failed to read image file'));
    };
    r.readAsDataURL(file);
  });
}

/** Data URLs for create/edit form thumbnails (parallel to picked {@link File} slots). */
export async function imageFilesToPreviewDataUrls(
  files: readonly (File | undefined)[],
): Promise<(string | undefined)[]> {
  return Promise.all(
    files.map((file) => (file ? readFileAsDataURL(file) : Promise.resolve(undefined))),
  );
}

/**
 * Builds the `images` array for `POST /assets/create`: each slot is either a Data URL from a picked
 * {@link File} or the existing string (https URL, `/path`, or server-relative path from the body).
 */
export async function wireAssetCreateImageStrings(
  pathStrings: string[],
  files: readonly (File | undefined)[],
): Promise<string[]> {
  const out: string[] = [];
  for (let i = 0; i < pathStrings.length; i++) {
    const file = files[i];
    if (file) {
      out.push(await readFileAsDataURL(file));
    } else {
      out.push(pathStrings[i]);
    }
  }
  return out;
}
